import { gql } from '@apollo/client';
import { FieldValueFragment } from '../fragments/FieldValueFragment';
/**
 * @const UpdateFieldValuesMutation
 * @since 1.0.0
 */
export const UpdateFieldValuesMutation = gql `
  mutation UpdateFieldValuesMutation($input: UpdateFieldValuesInput!) {
    updateFieldValues(input: $input) {
      ...FieldValueFragment
    }
  }

  ${FieldValueFragment}
`;
